export class AppError {
    constructor(
        public message: string,
        public code?: string,
        public details?: any
    ) { }
}